var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuzzer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 115,
    viewBox: "0 0 72 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72 14.5C72 22.5081 55.8823 29 36 29C16.1177 29 0 22.5081 0 14.5C0 6.4919 16.1177 0 36 0C55.8823 0 72 6.4919 72 14.5ZM36 17C40.9706 17 45 15.6569 45 14C45 12.3431 40.9706 11 36 11C31.0294 11 27 12.3431 27 14C27 15.6569 31.0294 17 36 17Z",
    fill: "#362C5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9503 28.463C55.8528 31.3217 46.3226 32.9996 36 32.9996C25.6774 32.9996 16.1472 31.3217 9.0497 28.463C5.7762 27.1445 2.5664 25.4304 0 22.9727V51.4745C0 57.7261 4.8724 60.2854 9.963 62.0376C26.8352 67.8451 45.1648 67.8451 62.037 62.0376C67.1276 60.2854 72 57.726 72 51.4745V22.9727C69.4336 25.4304 66.2238 27.1445 62.9503 28.463Z",
    fill: "#362C5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 66.2686V108.638C10.25 111.748 12.0409 114.269 14.25 114.269C16.4591 114.269 18.25 111.748 18.25 108.638V69.3286C15.558 68.4973 12.888 67.4772 10.25 66.2686Z",
    fill: "#AEA6C6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.25 70.086V108.678C52.25 111.765 54.0409 114.269 56.25 114.269C58.4591 114.269 60.25 111.765 60.25 108.678V67.2686C57.6099 68.3938 54.9399 69.333 52.25 70.086Z",
    fill: "#AEA6C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuzzer);
export default __webpack_public_path__ + "static/media/buzzer.5bfd2dce472a7289963eac9a630830be.svg";
export { ForwardRef as ReactComponent };